<template>
  <div class="mine-contain">
    <van-nav-bar :title="content.mineInfo" left-arrow @click-left="onClickLeft" />
    <div class="mine-container-p">
      <van-field
        v-model="perfectForm.name"
        :label="content.loginNameLabel"
        size="small"
        maxlength="15"
        :placeholder="content.loginNameTip"
        input-align="right"
      />
      <van-field
        :label="content.selectSexLabel"
        readonly
        clickable
        v-model="perfectForm.sex"
        size="small"
        :placeholder="content.selectSex"
        input-align="right"
        right-icon="arrow-down"
        @click="showSexPicker = true"
      />
      <van-field
        :label="content.selectBirthdayLabel"
        readonly
        clickable
        v-model="perfectForm.birthday"
        size="small"
        :placeholder="content.selectBirthday"
        input-align="right"
        right-icon="arrow-down"
        @click="showBirthdayPicker = true"
      />
      <van-field
        :label="content.selectTypeLabel"
        readonly
        clickable
        v-model="perfectForm.type"
        size="small"
        :placeholder="content.selectType"
        input-align="right"
        right-icon="arrow-down"
        @click="showPicker = true"
      />
      <van-field
        v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type)"
        :label="content.selectHospitalLabel"
        readonly
        clickable
        v-model="perfectForm.hospital_name"
        size="small"
        maxlength="30"
        :placeholder="content.selectHospital"
        input-align="right"
        right-icon="arrow-down"
        @click="showHospitalPicker = true"
      />
      <van-field
        v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type)"
        :label="content.selectOfficeLabel"
        readonly
        clickable
        v-model="perfectForm.hospital_offices"
        size="small"
        maxlength="20"
        :placeholder="content.selectOffice"
        input-align="right"
        right-icon="arrow-down"
        @click="showOfficesPicker = true"
      />
      <van-field
        v-if="['医生', '护士', '医技', '药师'].includes(perfectForm.type)"
        :label="content.selectJobTitleLabel"
        readonly
        clickable
        v-model="perfectForm.job_title"
        size="small"
        maxlength="15"
        :placeholder="content.selectJobTitle"
        input-align="right"
        right-icon="arrow-down"
        @click="showJobTitlePicker = true"
      />
      <van-field
        v-if="['医学生'].includes(perfectForm.type)"
        :label="content.selectSchoolLabel"
        readonly
        clickable
        v-model="perfectForm.school"
        size="small"
        maxlength="20"
        :placeholder="content.selectSchool"
        input-align="right"
        right-icon="arrow-down"
        @click="showSchoolPicker = true"
      />
      <van-field
        v-if="['医学生'].includes(perfectForm.type)"
        :label="content.selectSpecialtyLabel"
        v-model="perfectForm.specialty"
        size="small"
        maxlength="15"
        :placeholder="content.selectSpecialty"
        input-align="right"
      />
      <van-field
        v-if="['医学生'].includes(perfectForm.type)"
        :label="content.selectEducationLabel"
        readonly
        clickable
        v-model="perfectForm.education"
        size="small"
        maxlength="10"
        :placeholder="content.selectEducation"
        input-align="right"
        right-icon="arrow-down"
        @click="showEducationPicker = true"
      />
      <van-field
        v-if="['其他医务从业者', '非医务从业者'].includes(perfectForm.type)"
        :label="content.selectUnitLabel"
        v-model="perfectForm.work_unit"
        size="small"
        maxlength="30"
        :placeholder="content.selectUnit"
        input-align="right"
      />
      <van-field
        v-if="['其他医务从业者', '非医务从业者'].includes(perfectForm.type)"
        :label="content.selectPostLabel"
        v-model="perfectForm.post"
        size="small"
        maxlength="20"
        :placeholder="content.selectPost"
        input-align="right"
      />
      <van-field
        v-model="perfectForm.receiving_address"
        :label="content.shipAddressLabel"
        size="small"
        maxlength="30"
        :placeholder="content.shipAddressTip"
        input-align="right"
      />
      <div class="mine-btn-p">
        <van-button type="info" round block color="#1EAFFE" class="mine-btn" :disabled="!validForm" @click="perfectBtn">{{ content.mineSave }}</van-button>
        <van-button type="info" round block plain color="#1EAFFE" class="mine-btn" @click="logout">{{ content.mineLogout }}</van-button>
      </div>
    </div>
    <!--性别选择框-->
    <van-popup
      v-model="showSexPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="sexList"
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        @confirm="onSexConfirm"
        @cancel="showSexPicker = false"
      />
    </van-popup>
    <!--生日选择框-->
    <van-popup v-model="showBirthdayPicker" position="bottom">
      <van-datetime-picker
        v-model="selectBirthDay"
        type="date"
        :formatter="birthdayFormatter"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onBirthdayConfirm"
        @cancel="showBirthdayPicker = false"
      />
    </van-popup>
    <!--身份选择框-->
    <van-popup
      v-model="showPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        :columns="columns"
        value-key="name"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <!--科室选择框-->
    <van-popup
      v-model="showOfficesPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        :columns="officesList"
        value-key="title"
        @change="onOfficesChange"
        @confirm="onOfficesConfirm"
        @cancel="showOfficesPicker = false"
      />
    </van-popup>
    <!--医院选择框-->
    <van-popup
      v-model="showHospitalPicker"
      position="bottom"
    >
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="hospitalCancel">{{content.becancel}}</button>
        <!-- <button type="button" class="van-picker__confirm"></button> -->
      </div>
      <van-search v-model="hospitalSearch" :placeholder="content.selectKeyword" :clearable="false" @input="hospitalSearchInput"/>
      <div class="com-popup-p">
        <div v-if="hospitalSearch" class="com-popup-p-search">
          <div class="com-popup-p-item" v-html="highlightSearch(hospitalSearch, hospitalSearch)" @click="onHospitalConfirm(hospitalSearch)">
          </div>
          <div class="com-popup-p-item" v-for="(item, index) in hospitalList" :key="index" v-html="highlightSearch(item.name, hospitalSearch)" @click="onHospitalConfirm(item.name)">
          </div>
        </div>
        <div v-else class="com-popup-p-recommend">
          <div class="com-popup-p-item" v-for="(item, index) in hospitalRecommendList" :key="index" @click="onHospitalConfirm(item.hospital_name)">
            {{item.hospital_name}}
          </div>
        </div>
      </div>
    </van-popup>
    <!--职称选择框-->
    <van-popup
      v-model="showJobTitlePicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        :columns="jobTitleList"
        value-key="job_title"
        @confirm="onJobTitleConfirm"
        @cancel="showJobTitlePicker = false"
      />
    </van-popup>
    <!--学校选择框-->
    <van-popup
      v-model="showSchoolPicker"
      position="bottom"
    >
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="schoolCancel">{{content.becancel}}</button>
        <!-- <button type="button" class="van-picker__confirm"></button> -->
      </div>
      <van-search v-model="schoolSearch" :placeholder="content.selectKeyword" :clearable="false" @input="schoolSearchInput"/>
      <div class="com-popup-p">
        <div v-if="schoolSearch" class="com-popup-p-search">
          <div class="com-popup-p-item" v-for="(item, index) in schoolList" :key="index" v-html="highlightSearch(item.name, schoolSearch)" @click="onSchoolConfirm(item.name)">
          </div>
        </div>
        <div v-else class="com-popup-p-recommend">
          <div class="com-popup-p-item" v-for="(item, index) in schoolRecommendList" :key="index" @click="onSchoolConfirm(item.school)">
            {{item.school}}
          </div>
        </div>
      </div>
    </van-popup>
    <!--学历选择框-->
    <van-popup
      v-model="showEducationPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="educationList"
        :confirm-button-text="content.besure"
        :cancel-button-text="content.becancel"
        @confirm="onEducationConfirm"
        @cancel="showEducationPicker = false"
      />
    </van-popup>
    <van-dialog v-model="logoutShow" show-cancel-button :confirm-button-color="'#1EAFFE'" @confirm="logoutConfirm" @cancel="logoutShow=false">
      <div class="dialog-content">{{ content.mineLogoutTip }}</div>
    </van-dialog>
  </div>
</template>

<script>
import { postUserInfo, postUpdateMyInfo, postIdentityList, getAuthJobTitles, getAuthOffices, getHospitalRecommend,
  getSchoolRecommend, getAuthHospitals, getAuthSchools } from '@/models/common'
import { debounce, parseTime } from '@/utils/index.js'
export default {
  data() {
    return {
      memberId: '',
      perfectForm: {
        // 完善框表单
        type: '',
        code: 0,
        name: '',
        sex: '',
        birthday: '',
        hospital_name: '',
        hospital_offices: '',
        job_title: '',
        school: '',
        specialty: '',
        education: '',
        work_unit: '',
        post: '',
        receiving_address: '',
      },
      logoutShow: false, // 退出登录确认
      showSexPicker: false, // 性别选择器
      sexList: [
        '男', '女'
      ], // 性别列表
      minDate: new Date(1900,0,1),
      maxDate: new Date(),
      selectBirthDay: new Date(), // 默认日期
      showBirthdayPicker: false, // 生日选择器
      showPicker: false,
      columns: [], //身份 1001：医生1002：护士1003：医技1004：药师1005：医学生1006：其他医务从业者1007：非医务从业者
      showHospitalPicker: false, // 医院选择器
      hospitalSearch: '', // 医院关键词
      hospitalList: [], // 医院列表
      hospitalRecommendList: [], // 推荐医院列表
      showOfficesPicker: false, // 科室选择器
      officesList: [], // 科室列表
      officesLastList: [], // 科室最后一级列表，用于协助级联框回显
      officesFormData: '', // pc端科室级联回显项
      showJobTitlePicker: false, // 职称选择器
      jobTitleList: [], // 职称列表
      showSchoolPicker: false, // 学校选择器
      schoolSearch: '', // 学校关键词
      schoolList: [], // 学校列表
      schoolRecommendList: [], // 推荐学校列表
      showEducationPicker: false, // 学历选择器
      educationList: [
        '博士', '硕士', '本科', '大专', '高中/中专'
      ], // 学历列表
    }
  },
  computed: {
    validForm: function () {
      if(!this.perfectForm.sex?.trim() || !this.perfectForm.birthday?.trim()){
        return false
      }
      if (['医生', '护士', '医技', '药师'].includes(this.perfectForm.type)) {
        return (this.perfectForm.name?.trim() && this.perfectForm.hospital_name?.trim() && this.perfectForm.hospital_offices?.trim() && this.perfectForm.job_title?.trim())
      } else if (['医学生'].includes(this.perfectForm.type)) {
        return (this.perfectForm.name?.trim() && this.perfectForm.school?.trim() && this.perfectForm.specialty?.trim() && this.perfectForm.education?.trim())
      } else if (['其他医务从业者', '非医务从业者'].includes(this.perfectForm.type)) {
        return (this.perfectForm.name?.trim() && this.perfectForm.work_unit?.trim() && this.perfectForm.post?.trim())
      } else{
        return false
      }
    },
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    }
  },
  mounted() {
    this.getInfo()
    // 初始化身份列表
    postIdentityList().then(res => {
      if(res.data.code == 0) {
        this.columns = res.data.data
      }
    })
    // 初始化一级科室
    this.getOffices().then((data)=>{
      this.officesList = [{values: data}, {values: []}]
      if(data.length > 0) {
        this.getOffices(data[0].id).then((data)=>{
          this.officesList[1].values = data
        })
      }
    })
    // 初始化医院推荐
    getHospitalRecommend().then(res=>{
      if(res.data.code == 0){
        this.hospitalRecommendList = res.data.data
      }
    })
    // 初始化学校推荐
    getSchoolRecommend().then(res=>{
      if(res.data.code == 0){
        this.schoolRecommendList = res.data.data
      }
    })
    this.initWxBtns()
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1)
    },
    // 获取用户详情
    getInfo() {
      // 若地址不传则先取缓存的，没缓存则默认游客
      if (localStorage.getItem('loginItem')) {
        this.memberId = JSON.parse(localStorage.getItem('loginItem')).userId
      } else {
        this.memberId = '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
      }
      postUserInfo({
        member_id: this.memberId
      }).then(res=>{
        if(res.data.code == 0){
          this.perfectForm = res.data.data
          this.perfectForm.code = res.data.data.type
          this.perfectForm.sex = res.data.data.sex == 1 ? '男' : '女'
          switch (this.perfectForm.code) {
            case 1001:
              this.perfectForm.type = '医生';
              break;
            case 1002:
              this.perfectForm.type = '护士';
              break;
            case 1003:
              this.perfectForm.type = '医技';
              break;
            case 1004:
              this.perfectForm.type = '药师';
              break;
            case 1005:
              this.perfectForm.type = '医学生';
              break;
            case 1006:
              this.perfectForm.type = '其他医务从业者';
              break;
            case 1007:
              this.perfectForm.type = '非医务从业者';
              break;
            default:
              break;
          }
          if(res.data.data.birthday){
            this.selectBirthDay = new Date(res.data.data.birthday.replaceAll('-','/'))
          }
        }
      })
    },
    // 完善资料页按钮
    perfectBtn() {
      const _this = this
      const form = {
        member: {
          name: this.perfectForm.name,
          hospital_name: this.perfectForm.hospital_name,
          hospital_offices: this.perfectForm.hospital_offices,
          job_title: this.perfectForm.job_title,
          school: this.perfectForm.school,
          specialty: this.perfectForm.specialty,
          education: this.perfectForm.education,
          work_unit: this.perfectForm.work_unit,
          post: this.perfectForm.post,
          sex: this.perfectForm.sex == '男' ? 1 : 2,
          birthday: this.perfectForm.birthday,
        },
        member_id: this.memberId,
        receiving_address: this.perfectForm.receiving_address,
      }
      switch (this.perfectForm.type) {
        case '医生':
          form.type = 1001;
          break;
        case '护士':
          form.type = 1002;
          break;
        case '医技':
          form.type = 1003;
          break;
        case '药师':
          form.type = 1004;
          break;
        case '医学生':
          form.type = 1005;
          break;
        case '其他医务从业者':
          form.type = 1006;
          break;
        case '非医务从业者':
          form.type = 1007;
          break;
        default:
          break;
      }
      postUpdateMyInfo(form).then(res => {
        if (res.data.code == 0) {
          _this.$toast(_this.content.saveSuccess)
        } else {
          _this.$toast(_this.content.saveFail)
        }
      })
    },
    // 退出确认
    logout(){
      this.logoutShow = true
    },
    // 退出
    logoutConfirm(){
      this.logoutShow = false
      // localStorage.removeItem('loginItem')
      // localStorage.removeItem('x_token')
      // this.$router.replace({
      //   path: '/entry',
      //   query: {
      //     openId: this.$route.query.openId,
      //     conventionId: this.$route.query.conventionId,
      //     room: this.$route.query.room,
      //     live_meeting_id: this.$route.query.live_meeting_id,
      //     siteId: this.$route.query.siteId,
      //     video_id: this.$route.query.video_id,
      //   }
      // })
      this.$store.dispatch('logout')
    },
    // 选中性别
    onSexConfirm(value){
      this.perfectForm.sex = value
      this.showSexPicker = false
    },
    // 选择生日
    onBirthdayConfirm(date){
      this.selectBirthDay = date
      this.perfectForm.birthday = parseTime(date, '{y}-{m}-{d}')
      this.showBirthdayPicker = false
    },
    // 生日选择器格式化
    birthdayFormatter(type, val){
      if (type === 'year') {
        return val + '年'
      }
      if (type === 'month') {
        return val + '月'
      }
      if (type === 'day') {
        return val + '日'
      }
      return val
    },
    // 获取职称列表
    getJobTitles(code){
      getAuthJobTitles({
        identity_no: code
      }).then(res=>{
        if(res.data.code == 0) {
          this.jobTitleList = res.data.data
        }
      })
    },
    // 获取科室列表
    getOffices(pId = 0) {
      // console.log('获取科室列表---','mine')
      return new Promise((resolve, reject)=>{
        getAuthOffices({
          parent_id: pId
        }).then(res=>{
          if(res.data.code == 0) {
            resolve(res.data.data)
          }else {
            reject(res.data.data)
          }
        })
      })
    },
    // 选中身份
    onConfirm(value) {
      this.perfectForm.type = value.name
      this.perfectForm.code = value.code
      this.showPicker = false
      this.perfectForm.job_title = ''
      this.getJobTitles(value.code)
    },
    // 搜索医院
    hospitalSearchInput(){
      const _this = this
      debounce(()=>{
        if(_this.hospitalSearch) {
          getAuthHospitals({
            keyword: _this.hospitalSearch
          }).then(res=>{
            if(res.data.code == 0) {
              _this.hospitalList = res.data.data
            }
          })
        }
      }, 1000)()
    },
    // 选中医院
    onHospitalConfirm(name){
      this.perfectForm.hospital_name = name
      this.showHospitalPicker = false
    },
    // 取消医院弹出框
    hospitalCancel(){
      this.hospitalSearch = ''
      this.hospitalList = []
      this.showHospitalPicker = false
    },
    // 选中科室
    onOfficesConfirm(value){
      this.perfectForm.hospital_offices = value[1].title
      this.showOfficesPicker = false
    },
    // 科室选择变更事件
    onOfficesChange(picker, values) {
      // console.log(values);
      if(values[0].parent_id == 0){
        this.getOffices(values[0].id).then(data=>{
          picker.setColumnValues(1, data);
        })
      }
    },
    // 选中职称
    onJobTitleConfirm(value){
      this.perfectForm.job_title = value.job_title
      this.showJobTitlePicker = false
    },
    // 选中学历
    onEducationConfirm(value){
      this.perfectForm.education = value
      this.showEducationPicker = false
    },
    // 搜索学校
    schoolSearchInput(){
      const _this = this
      debounce(()=>{
        if(_this.schoolSearch) {
          getAuthSchools({
            name: _this.schoolSearch
          }).then(res=>{
            if(res.data.code == 0) {
              _this.schoolList = res.data.data
            }
          })
        }
      }, 1000)()
    },
    // 选中学校
    onSchoolConfirm(name){
      this.perfectForm.school = name
      this.showSchoolPicker = false
    },
    // 取消学校弹出框
    schoolCancel(){
      this.schoolSearch = ''
      this.schoolList = []
      this.showSchoolPicker = false
    },
    highlightSearch(name, key) {
      return name.replace(key, `<span class="search">${key}</span>`)
    },
    // 初始化微信按钮
    initWxBtns() {
      wx.ready(function() {
        wx.hideAllNonBaseMenuItem()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mine-contain {
  //   position: relative;
  height: 100%;
  background-color: #f7f8fa;
  /deep/.van-nav-bar {
    background-color: #1eaffe;
    .van-icon {
      color: #fff;
    }
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .mine-container-p {
    max-height: calc(100% - 0.61333rem);
    overflow-y: auto;
    .mine-btn-p {
      margin-top: 1.39rem;
      padding-bottom: 0.2rem;
      padding-left: 0.57rem;
      padding-right: 0.57rem;
      text-align: center;
      .mine-btn {
        // height: 0.59rem;
        // font-size: 0.24rem;
      }
      .mine-btn + .mine-btn {
        margin-top: 0.15rem;
      }
    }
  }
}
.dialog-content{
  padding: 0.3rem;
  text-align: center;
}
.van-popup{
  position: absolute;
}
.com-popup-p{
  height: 4rem;
  overflow-x: hidden;
  overflow-y: auto;
  padding-left: 0.23rem;
  padding-right: 0.23rem;
  padding-bottom: calc(env(safe-area-inset-bottom));
  .com-popup-p-search{}
  .com-popup-p-recommend{}
  .com-popup-p-item{
    padding: 0.13rem 0;
    font-size: 0.2rem;
    color: #AAAAAA;
    cursor: pointer;
    &:not(:first-child){
      border-top: 1px solid #E5E5E5;
    }
  }
  /deep/.search{
    color: #45A5E6;
  }
}
</style>
